import * as DismissibleLayerPrimitive from '@radix-ui/react-dismissable-layer';

export const DismissibleLayer = DismissibleLayerPrimitive.Root;

export type DismissibleLayerProps = DismissibleLayerPrimitive.DismissableLayerProps;
